module.exports = {
      id: "email-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }